<template>
    <button @click="logout()" class="link cur-p">{{ localizer.get("Account.Common.Logout") }}</button>
</template>

<script setup lang="ts">
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";

const localizer = Localizer;
const routes = (window as any).App.routes;

async function logout() {
    localStorage.removeItem("token");

    await Axios.post(routes.Account_Logout, null);

    window.location.href = routes.Home_Home;
}
</script>

